import React, { useRef, useState, useCallback } from "react";
import { IMaskInput } from "react-imask";

export function validarCNPJ(cnpj) {
  const nums = cnpj.replace(/\D/g, "");
  if (nums.length !== 14) return false;
  if (/^(\d)\1+$/.test(nums)) return false;

  const calc = (digits, pesos) => {
    const soma = digits.reduce((acc, d, i) => acc + d * pesos[i], 0);
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  const d = nums.split("").map(Number);
  const d1 = calc(d.slice(0, 12), [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  const d2 = calc(d.slice(0, 13), [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

  return d[12] === d1 && d[13] === d2;
}

/**
 * Input de CNPJ com máscara e validação dos dígitos verificadores.
 * A validação é automática — nenhuma prop extra é necessária nos componentes pai.
 * Props: value, onChange(val), placeholder, id, className, disabled.
 */
export default function CNPJ({
  value,
  onChange,
  onBlur,
  placeholder = "Informe o CNPJ",
  id,
  className = "form-control",
  disabled,
}) {
  const inputRef = useRef(null);
  const [erro, setErro] = useState("");

  const handleAccept = useCallback(
    (val) => {
      onChange && onChange(val || "");

      const nums = (val || "").replace(/\D/g, "");

      if (nums.length < 14) {
        setErro("");
        if (inputRef.current) inputRef.current.setCustomValidity("");
        return;
      }

      const valido = validarCNPJ(val);
      const msg = valido ? "" : "CNPJ inválido";
      setErro(msg);
      if (inputRef.current) inputRef.current.setCustomValidity(msg);
    },
    [onChange]
  );

  const classes = [className, erro ? "is-invalid" : ""].filter(Boolean).join(" ");

  return (
    <>
      <IMaskInput
        mask="00.000.000/0000-00"
        value={value ?? ""}
        onAccept={handleAccept}
        onBlur={onBlur}
        unmask={false}
        inputMode="numeric"
        placeholder={placeholder}
        className={classes}
        id={id}
        disabled={disabled}
        inputRef={inputRef}
      />
      {erro && <div className="invalid-feedback">{erro}</div>}
    </>
  );
}
